import { findCountryByKey } from '@/utils/country-config'

const findCountryByCurrency = (currency) =>
  findCountryByKey('currency', `${currency}`)

const getDecimalDigitsByCurrency = (currency) => {
  const countryFound = findCountryByCurrency(currency)
  const currencyDigits = countryFound?.currencyDigits

  if (!currencyDigits) {
    return 2
  }

  return currencyDigits
}

const getCKOPublicKeyByCurrency = (currency, isVersionV2 = false) => {
  const countryFound = findCountryByCurrency(currency)

  if (!countryFound) {
    return ''
  }

  if (isVersionV2 && !!countryFound.ckoPublicKeyV2) {
    return countryFound.ckoPublicKeyV2
  }

  return countryFound.ckoPublicKey || ''
}

export { getDecimalDigitsByCurrency, getCKOPublicKeyByCurrency }
